// export const baseURL = `http://127.0.0.1:8000/api`;
export const baseURL = `https://api.mohamadsnobar.com/api`;
export const REGISTER = "register";
export const LOGIN = "login";
export const PANEL = "panel";
export const LOGOUT = "logout";
export const USER = "user";
export const SOCIALLINKS = "social-links";
export const CLIENTS = "clients";
export const SERVICES = "services";
export const TAGS = "tags";
export const PROJECTS = "projects";
export const PORTFOLIO = "portfolio";
export const TESTIMONIAL = "testimonial";
export const CONTACT = "contact";
